import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Wrapper from "../components/Wrapper";
import Option from "../components/Option";
import Button from "../components/Button";
import {
  updateScreenAction,
  addScreenAction,
  backScreenAction,
} from "../actions";
import {
  INTENDED_APP,
  SHOW_MORE,
  WATER_SOURCE,
  WATER_TYPE,
} from "../constants";

function Question2({ screens, dispatch, updateScreen, addScreen, backScreen }) {
  const [tankwater, setTankwater] = useState(false);
  const [mainsAndTank, setMainsAndTank] = useState(false);
  const [other, setOther] = useState(false);

  const options = [
    {
      name: "Tank Water Only",
      iconName: "tankwater-only",
      optionClassName: `${tankwater ? "c-quiz_options--option-selected" : ""}`,
      action: () => {
        setTankwater(true);
        setMainsAndTank(false);
        setOther(false);
      },
    },

    {
      name: "Mains & Tankwater",
      iconName: "mains-tankwater",
      optionClassName: `${
        mainsAndTank ? "c-quiz_options--option-selected" : ""
      }`,
      action: () => {
        setTankwater(false);
        setMainsAndTank(true);
        setOther(false);
      },
    },
    {
      name: "Other",
      description: "E.g. bore water, river, dam etc.",
      iconName: "house-only-pressure-booster",
      optionClassName: `${other ? "c-quiz_options--option-selected" : ""}`,
      action: () => {
        setTankwater(false);
        setMainsAndTank(false);
        setOther(true);
      },
    },
  ];
  const getValue = () => {
    if (tankwater) {
      return "tank_water";
    } else if (mainsAndTank) {
      return "mains_and_tank";
    } else {
      return "other";
    }
  };
  
  const isBtnDisabled = !tankwater && !mainsAndTank && !other;
  useEffect(() => {
    if (screens.answers.WATER_SOURCE) {
      if (screens.answers.WATER_SOURCE === "tank_water") {
        setTankwater(true);
      }
      if (screens.answers.WATER_SOURCE === "mains_and_tank") {
        setMainsAndTank(true);
      }
    }
  }, [screens.answers.WATER_SOURCE]);

  return (
    <Wrapper stepNo={"2"} question={"2. What is the water source?"}>
      <div
        className="uk-child-width-expand@s uk-text-center uk-grid-match c-quiz_options"
        uk-grid="margin: uk-margin-small uk-margin@s"
      >
        {options.map((option) => {
          return (
            <Option
              key={`opt_${option.name}`}
              name={option.name}
              iconName={option.iconName}
              description={option.description}
              optionClassName={option.optionClassName}
              onClick={option.action}
            />
          );
        })}
      </div>

      <div>
        <Button
          text={"Back"}
          secondary
          onClick={() => {
            backScreen({
              back_screen: WATER_TYPE,
            });
          }}
        />

        <Button
          text={"continue"}
          disabled={isBtnDisabled}
          onClick={() => {
            const value = getValue();
            if (other) {
              updateScreen({
                curr_screen: WATER_SOURCE,
                next_screen: SHOW_MORE,
                answer: value,
              });
            } else {
              updateScreen({
                curr_screen: WATER_SOURCE,
                next_screen: INTENDED_APP,
                answer: value,
              });
            }
          }}
        />
      </div>
    </Wrapper>
  );
}

const mapStateToProps = (state) => ({
  screens: state.questions,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateScreen: updateScreenAction,
      addScreen: addScreenAction,
      backScreen: backScreenAction,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(Question2);
